import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import QuestionNavigator from './QuestionNavigator';
import ResponseCard from './ResponseCard';
import {useFormsContext} from '../../../../../../context/forms/FormsContextProvider';

function ResponseByQuestion({
  printableRef,
}: {
  printableRef: React.RefObject<HTMLDivElement | null>;
}) {
  const {t} = useTranslation();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const {formData} = useFormsContext();

  // const data = MOCK_RESPONSES_DATA;
  const totalQuestions = formData?.questions?.length || 0;
  const currentQuestion = formData?.responses?.[currentQuestionIndex];

  const handlePrev = () => {
    setCurrentQuestionIndex(prev => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setCurrentQuestionIndex(prev => Math.min(totalQuestions - 1, prev + 1));
  };

  // Empty state
  if (totalQuestions === 0) {
    return (
      <div className="flex flex-col items-center justify-center p-12 min-h-[300px]">
        <div className="text-center">
          <p className="text-xl text-gray">
            {t('forms.dialog.responses.empty')}
          </p>
        </div>
      </div>
    );
  }
  const {linearScale, rating, image, rangeConfig} = currentQuestion?.question;
  const metaData = {
    maxRating: rating?.max,
    ratingIcon: rating?.icon,
    // For linear-scale questions
    fromValue: linearScale?.min,
    toValue: linearScale?.max,
    fromLabel: linearScale?.minLabel,
    toLabel: linearScale?.maxLabel,
    // question image
    qImage: image,

    // question range
    qRange: rangeConfig,
  };

  return (
    <div className="flex-1 min-h-0 flex flex-col" ref={printableRef}>
      {/* Question navigator */}
      <QuestionNavigator
        questionTitle={currentQuestion?.question?.title}
        currentIndex={currentQuestionIndex}
        totalQuestions={totalQuestions}
        totalResponders={currentQuestion?.answers?.length || 0}
        showTotalResponders={formData?.countRespondents}
        onPrev={handlePrev}
        onNext={handleNext}
      />

      {/* Border separator */}
      <div className="border-t border-gray80 mt-4 flex-shrink-0" />

      {/* Scrollable response list */}
      <div className="flex-1 min-h-0 overflow-y-auto mt-4 flex flex-col gap-3">
        {currentQuestion?.answers?.map((response: any, idx: number) => (
          <ResponseCard
            key={idx}
            response={response}
            questionType={currentQuestion?.question?.type}
            metadata={metaData}
          />
        ))}
      </div>
    </div>
  );
}

export default ResponseByQuestion;
